var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92188 6.36719H24.7363V8.4893H6.92188V6.36719Z",
    fill: "#0EA5E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 3H22.4101V4.76837H9.25V3Z",
    fill: "#0EA5E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60938 10.6094V22.7542C4.60938 23.8797 5.05655 24.9594 5.8524 25.7552C6.64826 26.5511 7.72775 26.9982 8.85339 26.9982H22.7524C23.8781 26.9982 24.9575 26.5511 25.7534 25.7552C26.5492 24.9594 26.9964 23.8797 26.9964 22.7542V10.6094H4.60938ZM15.9267 22.2802H15.9265C15.411 22.7969 14.7113 23.0871 13.9813 23.0871C13.2516 23.0871 12.5517 22.7969 12.0362 22.2802L9.72322 19.9743L11.2227 18.4748L13.5357 20.7878C13.655 20.9066 13.8166 20.9733 13.9848 20.9733C14.1532 20.9733 14.3148 20.9066 14.434 20.7878L20.3825 14.8319L21.882 16.3314L15.9267 22.2802Z",
    fill: "#0EA5E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/Total.d93fe230ce3d6421d9b073296e3758ad.svg";
export { ForwardRef as ReactComponent };